import { useEffect, useRef } from 'react';
import { useLocation, useNavigationType } from 'react-router-dom';

export default function ScrollManager() {
  const { pathname, hash } = useLocation();
  const navigationType = useNavigationType();
  // Read at effect time without making the effect depend on it: filters replace the entry on
  // every keystroke, and that must not move the page.
  const navigationTypeRef = useRef(navigationType);
  navigationTypeRef.current = navigationType;

  useEffect(() => {
    if (hash) {
      document.querySelector(hash)?.scrollIntoView({ behavior: 'smooth' });
      return;
    }

    // Going back or forward, the browser puts the reader where they were. Opening a page is
    // different: without this, the offset from the previous page carries over, and on a short
    // page it lands at the bottom instead of at the title.
    if (navigationTypeRef.current === 'POP') return;

    window.scrollTo(0, 0);
  }, [pathname, hash]);

  return null;
}
